import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { validateDirectJobInvite, DirectJobInviteInfo } from '../api/directJobInvite';
import Register from '../components/Register';

type Status = 'validating' | 'valid' | 'invalid';

const AcceptDirectJobInvitePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';

  const [status, setStatus] = useState<Status>(token && email ? 'validating' : 'invalid');
  const [info, setInfo] = useState<DirectJobInviteInfo | null>(null);

  useEffect(() => {
    if (status !== 'validating') return;
    validateDirectJobInvite(token, email)
      .then((data) => {
        setInfo(data);
        setStatus('valid');
      })
      .catch(() => setStatus('invalid'));
  }, []); // Run once on mount

  if (status === 'validating') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface py-12 px-4">
        <p className="text-on-surface-variant">Checking your invite...</p>
      </div>
    );
  }

  if (status === 'invalid') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface py-12 px-4">
        <div className="max-w-md w-full text-center space-y-3">
          <h2 className="text-2xl font-bold text-on-surface">This invite link is invalid or has expired</h2>
          <p className="text-on-surface-variant text-sm">Ask the contractor who sent it to create a new Direct Job.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface">
      <div className="max-w-md mx-auto pt-12 px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-on-surface-variant text-sm">
          <span className="font-semibold text-on-surface">{info?.contractorCompanyName}</span> sent you a Quote for
          {' '}<span className="font-semibold text-on-surface">{info?.jobTitle}</span>. Create a free account to view it.
        </p>
      </div>
      <Register initialEmail={email} lockToClientStep />
    </div>
  );
};

export default AcceptDirectJobInvitePage;
